export default "__VITE_ASSET__CVUAjAnF__"